import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class Party extends EntityBase {
  public Number: number;
  public FirstName: string;
  public LastName: string;
  public DisplayName: string;
  public Description: string;
  public PersonalityKindId?: number;
  public PersonalityKindTitle: string;
  public PersonalityKindCode?: number;
  public NationalId: string;
  public NationalCode: string;
  public DetailLedgerId?: number;
  public SubLedgerId?: number;
}
